import React from 'react';
import { Bell, BellOff, BellRing } from 'lucide-react';
import { Button } from './ui/button';
import { useLanguage } from '../contexts/LanguageContext';
import { usePushNotifications } from '../hooks/usePushNotifications';
import { toast } from 'sonner';

const texts = {
  fr: { enable: 'Activer les notifications', disable: 'Désactiver', denied: 'Notifications bloquées', notsupported: 'Non supporté' },
  en: { enable: 'Enable notifications', disable: 'Disable', denied: 'Notifications blocked', notsupported: 'Not supported' },
  de: { enable: 'Benachrichtigungen aktivieren', disable: 'Deaktivieren', denied: 'Blockiert', notsupported: 'Nicht unterstützt' },
  es: { enable: 'Activar notificaciones', disable: 'Desactivar', denied: 'Bloqueadas', notsupported: 'No soportado' },
  pt: { enable: 'Ativar notificações', disable: 'Desativar', denied: 'Bloqueadas', notsupported: 'Não suportado' },
  it: { enable: 'Attiva notifiche', disable: 'Disattiva', denied: 'Bloccate', notsupported: 'Non supportato' },
  ar: { enable: 'تفعيل الإشعارات', disable: 'إلغاء', denied: 'محظورة', notsupported: 'غير مدعوم' },
  lb: { enable: 'Notifikatiounen aktivéieren', disable: 'Deaktivéieren', denied: 'Blockéiert', notsupported: 'Net ënnerstëtzt' }
};

const PushNotificationToggle = ({ token, variant = 'default' }) => {
  const { language } = useLanguage();
  const ct = texts[language] || texts.fr;
  const { isSupported, isSubscribed, permission, subscribe, unsubscribe } = usePushNotifications(token);

  if (!isSupported) {
    return variant === 'compact' ? null : (
      <span className="text-xs text-slate-400">{ct.notsupported}</span>
    );
  }

  if (permission === 'denied') {
    return (
      <Button variant="outline" size="sm" disabled className="gap-2 opacity-50">
        <BellOff className="w-4 h-4" />
        {variant !== 'compact' && ct.denied}
      </Button>
    );
  }

  const handleToggle = async () => {
    if (isSubscribed) {
      const ok = await unsubscribe();
      if (ok) toast.success('Notifications désactivées');
    } else {
      const ok = await subscribe();
      if (ok) toast.success('Notifications activées !');
      else toast.error('Impossible d\'activer les notifications');
    }
  };

  return (
    <Button
      variant={isSubscribed ? 'default' : 'outline'}
      size="sm"
      onClick={handleToggle}
      className={`gap-2 ${isSubscribed ? 'bg-emerald-600 hover:bg-emerald-700' : ''}`}
      data-testid="push-notification-toggle"
    >
      {isSubscribed ? <BellRing className="w-4 h-4" /> : <Bell className="w-4 h-4" />}
      {variant !== 'compact' && (isSubscribed ? ct.disable : ct.enable)}
    </Button>
  );
};

export default PushNotificationToggle;
